export default __webpack_public_path__ + "static/media/edit.7d4e235b.svg";